import { http } from '../http';

export const getResetPasswordUrl = async () => {
  try {
    const url = '/auth/reset-password';
    const response = await http.get(url, { baseURL: process.env.BFFV2_BASE_URL });
    if (!response?.data?.resetUrl) {
      throw new Error("Can't get reset password url");
    }
    return response?.data?.resetUrl;
  } catch (e) {
    console.error('something went wrong', e);
    throw e;
  }
};

export default {
  getResetPasswordUrl,
};
